module.exports = __webpack_public_path__ + "img/wdsd.4bbb8b7b.png";